"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import style from "../../../style.module.css";
import { tabIcons } from "@/shared/constants/icons";
import { cn } from "@/shared/libs/commonUtils";
import Flex from "@/shared/components/common/Flex";
import Typography from "@/shared/components/common/Typography";
import Grid from "@/shared/components/common/Grid";
import { useDeviceType } from "@/shared/context/DeviceContext";

export interface TabItemProps {
  title: string;
  icon: string;
  link: string;
  activeLink?: string | null;
}

export default function TabItem({ icon, link, title, activeLink }: TabItemProps) {
  const pathname = usePathname();
  const normalizedPathname =
    pathname === "/" ? pathname : pathname.replace(/\/$/, "");
  const device = useDeviceType();
  const isActive =
    activeLink === null
      ? false
      : activeLink === undefined
        ? normalizedPathname === link
        : link === activeLink;

  return (
    <Grid.GridCol
      key={title}
      className={cn(
        style.tab,
        `max-md:h-full ${
          isActive &&
          "md:text-primary sm:border-b-4 sm:border-primary md:[&_svg]:fill-primary"
        }`,
      )}
    >
      <Link href={link} className="w-full">
        {device === "desktop" ? (
          <Flex className="max-md:flex-col items-center md:justify-center gap-x-2 max-md:gap-1">
            {tabIcons[icon]}
            <Flex className="items-center gap-x-1">
              <Typography className={cn(style.font, "max-md:text-center")}>
                {title}
              </Typography>
            </Flex>
          </Flex>
        ) : (
          <Flex className="group min-w-[88px] max-md:flex-col items-center justify-center gap-1 rounded-lg border border-white/80 bg-white/95 px-3.5 py-2 text-foreground shadow-[0_6px_16px_rgba(15,23,42,0.09)] ring-1 ring-black/5 backdrop-blur transition duration-200 active:scale-[0.98]">
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary/10 text-primary transition duration-200 group-active:bg-primary/15 [&_svg]:h-[18px] [&_svg]:w-[18px] [&_svg]:fill-primary">
              {tabIcons[icon]}
            </span>
            <Flex className="items-center gap-x-1">
              <Typography className={cn(style.font, "max-md:text-center max-md:text-xs max-md:leading-5")}>
                {title}
              </Typography>
            </Flex>
          </Flex>
        )}
      </Link>
    </Grid.GridCol>
  );
}
